import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { wrapperUseDynamicDNSSupport, wrapperSetServerSessionStorageParams } from '../javascript.js';

@Injectable()
export class ScanWritrHttpInterceptor implements HttpInterceptor {

  constructor(
    private router: Router
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // update request URL
    let newUrl = req.url;
    if (req.url.startsWith('api/') && wrapperUseDynamicDNSSupport()) {

      wrapperSetServerSessionStorageParams(req.url);
      newUrl = sessionStorage.getItem('baseUrl') + req.url;
      console.log('Changing API url from ' + req.url + ' to ' + newUrl);

      // disable IE ajax request caching
      const newReq = req.clone({
        headers: req.headers.set('If-Modified-Since', 'Mon, 26 Jul 1997 05:00:00 GMT')
          .set('Cache-Control', 'no-cache')
          .set('Pragma', 'no-cache')
          .set('X-ss-id', sessionStorage.getItem('baseServerId'))
          .set('X-ss-pid', sessionStorage.getItem('baseServerPid')),
        withCredentials: true,
        url: newUrl
      });

      // Pass the cloned request instead of the original request to the next handle
      return next.handle(newReq);

    } else {

      // disable IE ajax request caching
      const newReq = req.clone({
        headers: req.headers.set('If-Modified-Since', 'Mon, 26 Jul 1997 05:00:00 GMT')
          .set('Cache-Control', 'no-cache')
          .set('Pragma', 'no-cache')
      });

      // Pass the cloned request instead of the original request to the next handle
      return next.handle(newReq);
    }

  }

}
